import axios from 'axios';
import type { CompatibleListApiResponse } from './types';

/**
 * Fetch compatibility list from Next.js API proxy (getcompatiblelist).
 */
export const fetchCompatibleList = async (
  productId: number,
  domain?: string
): Promise<CompatibleListApiResponse> => {
  try {
    const response = await axios.get<CompatibleListApiResponse>('/api/ymm-compatible', {
      params: { productId, domain },
      headers: { Accept: 'application/json' },
    });

    return response.data;
  } catch (error) {
    console.error('Compatible list API error:', error);

    if (axios.isAxiosError(error)) {
      const message =
        error.response?.data?.error ?? error.response?.statusText ?? error.message;
      throw new Error(`Failed to fetch compatibility: ${message}`);
    }

    throw new Error(
      `Failed to fetch compatibility: ${error instanceof Error ? error.message : 'Unknown error'}`
    );
  }
};
